import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import TcNav from "./TcNav";import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

function AddLaw() {
  const navigate = useNavigate();

  const [laws, setLaws] = useState([]);

  const getLaws = async () => {
    try {
      const response = await fetch("http://localhost:8000/laws");
      const data = await response.json();
      setLaws(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getLaws();
  }, []);

  const deleteLaw = async (id) => {
    const authString = localStorage.getItem("user");
    const auth = authString ? JSON.parse(authString) : [];
    console.warn(auth);
    if (auth[0].userType === "super") {
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this law?"
      );

      if (isConfirmed) {
        try {
          let result = await fetch(`http://localhost:8000/laws/${id}`, {
            method: "Delete",
          });
          result = await result.json();
          if (result) {
            toast.success("Law Deleted", {
              position: "top-left",
              autoClose: 2000,
              theme: "dark",
            });
            getLaws();
          }
        } catch (error) {
          console.error("Error during fetch operation:", error);
        }
      }
    }
    else{
      toast.error("You are not authorised to perform the action!", {
        position: "top-left",
        autoClose: 2000,
        theme: "dark",
      });

    }
  };

  const [formData, setFormData] = useState({
    violations: "",
    fine: "",
  });

  // Function to handle changes in input fields
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Manipulate the "fine" value before sending it to the server
      const formDataWithTk = {
        ...formData,
        fine: "Tk. " + formData.fine,
      };
      // Send a POST request to the server with form data
      let result = await fetch("http://localhost:8000/laws", {
        method: "POST",
        body: JSON.stringify(formDataWithTk),
        headers: {
          "Content-Type": "application/json",
        },
      });

      // console.warn(formData);
      // Parse the response as JSON
      result = await result.json();

      // If successful, update local state with the new law
      if (result) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error during fetch operation:", error);
    }
  };

  return (
    <div>
      <header>
        <TcNav />
      </header>
      <main className="mt-4 mb-4">
        <div className="container mt-4 mb-4 d-flex  flex-column justify-content-center align-items-center">
          <div class=" input-group .bg-light-subtle w-50  mb-3 searches">
            <input
              type="text"
              className="form-control"
              placeholder="Input Violation Rule"
              name="violations"
              value={formData.violations}
              onChange={handleChange}
            />
            <input
              type="text"
              className="form-control"
              placeholder="Input Fine"
              name="fine"
              value={formData.fine}
              onChange={handleChange}
            />
            <button
              onClick={handleSubmit}
              type="submit"
              className="btn btn-outline-light"
            >
              Submit New Law
            </button>
          </div>
          <div className="container">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Violation</th>
                  <th>Fine</th>
                  <th>Operations</th>
                </tr>
              </thead>
              <tbody>
                {laws.map((law) => (
                  <tr key={law.id}>
                    <td>{law.id}</td>
                    <td>{law.violations}</td>
                    <td>{law.fine}</td>
                    <td>
                      <NavLink
                        className="btn btn-subtle"
                        to={"/update/laws/" + law.id}
                      >
                        Update Data
                      </NavLink>
                      <button
                        className="btn btn-outline-danger"
                        onClick={() => deleteLaw(law.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main><ToastContainer/>
    </div>
  );
}

export default AddLaw;
